module.exports = __webpack_public_path__ + "img/financely-design.84da79d1.png";